import { DateTime } from 'luxon';
var dt = DateTime.local();
// TODO: Replace Luxon's DateTime.local().toLocaleString(DateTime.DATE_HUGE) with Day.js equivalent
// const formattedDate = dayjs().format('MMMM D, YYYY');
export var DateRanges = {
    yesterday: {
        startDate: dt.minus({ day: 1 }).toISODate(),
        endDate: dt.minus({ day: 1 }).toISODate(),
    },
    last7Days: {
        startDate: dt.minus({ days: 6 }).toISODate(),
        endDate: dt.toISODate(),
    },
    last30Days: {
        startDate: dt.minus({ days: 29 }).toISODate(),
        endDate: dt.toISODate(),
    },
    thisMonth: {
        startDate: dt.set({ day: 1 }).toISODate(),
        endDate: dt.toISODate(),
    },
    lastMonth: {
        startDate: dt.minus({ months: 1 }).startOf('month').toISODate(),
        endDate: dt.minus({ months: 1 }).endOf('month').toISODate(),
    },
    last90Days: {
        startDate: dt.minus({ days: 89 }).toISODate(),
        endDate: dt.toISODate(),
    },
    last6Months: {
        startDate: dt.minus({ months: 6 }).toISODate(),
        endDate: dt.toISODate(),
    },
    last12Months: {
        startDate: dt.minus({ months: 12 }).toISODate(),
        endDate: dt.toISODate(),
    },
    last25Months: {
        startDate: dt.minus({ months: 25 }).toISODate(),
        endDate: dt.toISODate(),
    },
    last2Years: {
        startDate: dt.minus({ months: 25 }).toISODate(),
        endDate: dt.toISODate(),
    },
    thisYear: {
        startDate: dt.startOf('year').toISODate(),
        endDate: dt.toISODate(),
    },
    lastYear: {
        startDate: dt.minus({ years: 1 }).startOf('year').toISODate(),
        endDate: dt.minus({ years: 1 }).endOf('year').toISODate(),
    },
    twoYearsPrior: {
        startDate: dt.minus({ years: 2 }).startOf('year').toISODate(),
        endDate: dt.minus({ years: 2 }).endOf('year').toISODate(),
    },
    threeYearsPrior: {
        startDate: dt.minus({ years: 3 }).startOf('year').toISODate(),
        endDate: dt.minus({ years: 3 }).endOf('year').toISODate(),
    },
    fourYearsPrior: {
        startDate: dt.minus({ years: 4 }).startOf('year').toISODate(),
        endDate: dt.minus({ years: 4 }).endOf('year').toISODate(),
    },
    fiveYearsPrior: {
        startDate: dt.minus({ years: 5 }).startOf('year').toISODate(),
        endDate: dt.minus({ years: 5 }).endOf('year').toISODate(),
    },
    sixYearsPrior: {
        startDate: dt.minus({ years: 6 }).startOf('year').toISODate(),
        endDate: dt.minus({ years: 6 }).endOf('year').toISODate(),
    },
    YTD: {
        startDate: dt.set({ day: 1 }).set({ month: 1 }).toISODate(),
        endDate: dt.toISODate(),
    },
    recentOrders: {
        startDate: dt.minus({ months: 25 }).toISODate(),
        endDate: dt.toISODate(),
    },
    last7Years: {
        startDate: dt.minus({ months: 85 }).toISODate(),
        endDate: dt.toISODate(),
    },
    custom: {
        startDate: '',
        endDate: '',
    },
};
